import { connect } from 'react-redux';
import { PowerSupplyLead as Component } from './PowerSupplyLead';
import {
  setPowerSupplyLeadPostive,
  setPowerSupplyLeadNegative,
  setPowerSupplyAnodeConnected,
  setPowerSupplyCathodeConnected,
  setGelBoxAnodeConnected,
  setGelBoxCathodeConnected,
  setPositiveLeadConnection,
  setNegativeLeadConnection,
  pushInteractions,
  setPowerSupplyLeadHeld,
  setPowerSupplyLeadControlVisibility,
  setMoveMenu,
  showMoveMenu,
  hideAllControls,
  createPowerSupplyLead,
  setHeld,
  setHeldObject,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if (state.notebook.protocolSection.scene.apparatus.hasOwnProperty("powerSupplyLead") &&
    state.notebook.protocolSection.scene.apparatus.powerSupplyLead.some(
      powerSupplyLead => powerSupplyLead.id === ownProps.id
    )
  ) {
    return {

      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.powerSupplyLead.type,
      //moveMenuDisplay: state.notebook.protocolSection.scene.apparatus.moveMenu.display,
      positiveLead: state.notebook.protocolSection.scene.apparatus.powerSupplyLead[ownProps.id -1].positiveLead,
      negativeLead: state.notebook.protocolSection.scene.apparatus.powerSupplyLead[ownProps.id -1].negativeLead,
      positiveLead1: state.notebook.protocolSection.scene.apparatus.powerSupplyLead[ownProps.id -1].positiveLeads['1'],
      negativeLead1: state.notebook.protocolSection.scene.apparatus.powerSupplyLead[ownProps.id -1].negativeLeads['1'],
      positiveLead2: state.notebook.protocolSection.scene.apparatus.powerSupplyLead[ownProps.id -1].positiveLeads['2'],
      negativeLead2: state.notebook.protocolSection.scene.apparatus.powerSupplyLead[ownProps.id -1].negativeLeads['2'],
      leads: state.notebook.protocolSection.scene.apparatus.powerSupplyLead[ownProps.id -1].leads,
      description: null,
      interactionProps: {
        gelBoxes: state.notebook.protocolSection.scene.apparatus.gelBoxes,
        powerSupply: state.notebook.protocolSection.scene.apparatus.powerSupply
      }
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setPowerSupplyLeadPostive: (data) => {
      dispatch(setPowerSupplyLeadPostive(data))
    },
    setPowerSupplyLeadNegative: (data) => {
      dispatch(setPowerSupplyLeadNegative(data))
    },
    setPowerSupplyAnodeConnected: (data) => {
      dispatch(setPowerSupplyAnodeConnected(data))
    },
    setPowerSupplyCathodeConnected: (data) => {
      dispatch(setPowerSupplyCathodeConnected(data))
    },
    setGelBoxAnodeConnected: (data) => {
      dispatch(setGelBoxAnodeConnected(data))
    },
    setGelBoxCathodeConnected: (data) => {
      dispatch(setGelBoxCathodeConnected(data))
    },
    setPositiveLeadConnection: (data) => {
      dispatch(setPositiveLeadConnection(data))
    },
    setNegativeLeadConnection: (data) => {
      dispatch(setNegativeLeadConnection(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    setPowerSupplyLeadHeld: (data) => {
      dispatch(setPowerSupplyLeadHeld(data))
    },
    setPowerSupplyLeadControlVisibility: (data) => {
      dispatch(setPowerSupplyLeadControlVisibility(data))
    },
    setMoveMenu: (data) => {
      dispatch(setMoveMenu(data))
    },
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    },

    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    createPowerSupplyLead: (data) => {
      dispatch(createPowerSupplyLead(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
  };
}

export const PowerSupplyLead = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
